import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import useSeo from "@/hooks/useSeo";

export default function ManageBooking() {
  useSeo("Manage Booking", "Find your Ananta Hotels booking using your booking ID and email.");
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ booking_id: params.get("id") || "", email: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/bookings/lookup", f);
      nav(`/booking/${data.booking_id}?t=${data.token}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="container-x py-20 sm:py-28 max-w-xl">
      <p className="eyebrow text-[#C28B5E]">Reservations</p>
      <h1 className="mt-3 text-4xl sm:text-5xl text-[#1E3B2E] tracking-tight">Manage booking</h1>
      <p className="mt-4 text-sm text-[#6b6b6b]">Enter the booking ID from your confirmation email and the email used to book.</p>
      <form onSubmit={submit} className="mt-10 space-y-4" data-testid="manage-booking-form">
        <label className="eyebrow !text-[10px] text-[#6b6b6b] block" htmlFor="mb-id">Booking ID</label>
        <input id="mb-id" className="field uppercase tracking-wider" placeholder="Booking ID (e.g. ANTXXXXXXXX)" value={f.booking_id} onChange={(e) => setF({ ...f, booking_id: e.target.value })} required data-testid="manage-booking-id-input" />
        <label className="eyebrow !text-[10px] text-[#6b6b6b] block" htmlFor="mb-email">Email</label>
        <input id="mb-email" type="email" className="field" placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="manage-booking-email-input" />
        <button className="btn-primary w-full" disabled={busy} data-testid="manage-booking-submit-btn">Find my booking</button>
      </form>
    </section>
  );
}
